<template>
  <v-speed-dial
    v-model="fab"
    bottom
    right
    fixed
    :open-on-hover="$vuetify.breakpoint.mdAndUp"
  >
    <v-btn
      slot="activator"
      v-model="fab"
      color="primary"
      dark
      fab
      hover
    >
      <v-icon>build</v-icon>
      <v-icon>close</v-icon>
    </v-btn>
    <v-tooltip left>
      <v-btn
        slot="activator"
        fab
        dark
        small
        color="secondary"
        @click.stop="onClick('addProvider')"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <span v-t="'editingContainer.addProvider'" />
    </v-tooltip>
    <v-tooltip left>
      <v-btn
        slot="activator"
        fab
        dark
        small
        color="secondary"
        @click.stop="onClick('showLink')"
      >
        <v-icon>link</v-icon>
      </v-btn>
      <span v-t="'editingContainer.getLink'" />
    </v-tooltip>
    <v-tooltip left>
      <v-btn
        slot="activator"
        fab
        dark
        small
        color="secondary"
        @click.stop="onClick('copyProvider')"
      >
        <v-icon>content_copy</v-icon>
      </v-btn>
      <span v-t="'editingContainer.copyProvider'" />
    </v-tooltip>
    <v-tooltip left>
      <v-btn
        slot="activator"
        fab
        dark
        small
        color="secondary"
        @click.stop="onClick('manageProviders')"
      >
        <v-icon>edit</v-icon>
      </v-btn>
      <span v-t="'editingContainer.manageProviders'" />
    </v-tooltip>
  </v-speed-dial>
</template>

<script>
export default {
  name: 'EditingButton',
  data() {
    return {
      fab: false,
    };
  },
  methods: {
    onClick(emit) {
      this.$emit(emit);
      this.fab = false;
    },
  },
};
</script>
